export const SHIPPING_FETCH_START = 'SHIPPING_FETCH_START';
export const SHIPPING_FETCH_SUCCESS = 'SHIPPING_FETCH_SUCCESS';
export const SHIPPING_FETCH_FAIL = 'SHIPPING_FETCH_FAIL';

export const DELETE_SHIPPING_START = 'DELETE_SHIPPING_START';
export const DELETE_SHIPPING_SUCCESS = 'DELETE_SHIPPING_SUCCESS';
export const DELETE_SHIPPING_FAIL = 'DELETE_SHIPPING_FAIL';
export const DELETE_SHIPPING_RESET = 'DELETE_SHIPPING_RESET';

export const CREATE_SHIPPING_START = 'CREATE_SHIPPING_START';
export const CREATE_SHIPPING_SUCCESS = 'CREATE_SHIPPING_SUCCESS';
export const CREATE_SHIPPING_FAIL = 'CREATE_SHIPPING_FAIL';
export const CREATE_SHIPPING_RESET = 'CREATE_SHIPPING_RESET';

export const EDIT_SHIPPING_START = 'EDIT_SHIPPING_START';
export const EDIT_SHIPPING_SUCCESS = 'EDIT_SHIPPING_SUCCESS';
export const EDIT_SHIPPING_FAIL = 'EDIT_SHIPPING_FAIL';
export const EDIT_SHIPPING_RESET = 'EDIT_SHIPPING_RESET';

export const SHIPPINGLIST_FETCH_START = 'SHIPPINGLIST_FETCH_START';
export const SHIPPINGLIST_FETCH_SUCCESS = 'SHIPPINGLIST_FETCH_SUCCESS';
export const SHIPPINGLIST_FETCH_ERROR = 'SHIPPINGLIST_FETCH_ERROR';


export const ADD_TO_SHIPPING_ITEM = 'ADD_TO_SHIPPING_ITEM';
export const SHIPPING_SAVE_SHIPPING_ADDRESS = 'SHIPPING_SAVE_SHIPPING_ADDRESS';
export const SHIPPING_RESET = 'SHIPPING_RESET';
